import fs from 'node:fs'
import path from 'node:path'
import os from 'node:os'

export async function runUninstall(): Promise<void> {
  // 1. Remove command stubs directory
  const commandsGmDir = path.join(os.homedir(), '.claude', 'commands', 'gm')
  if (fs.existsSync(commandsGmDir)) {
    fs.rmSync(commandsGmDir, { recursive: true, force: true })
    console.log('  Removed command stubs from ~/.claude/commands/gm/')
  } else {
    console.log('  ~/.claude/commands/gm/ not found — skipping')
  }

  // 2. Remove deployed assets
  const gsdMunchHome = path.join(os.homedir(), '.claude', 'gsd-munch')
  if (fs.existsSync(gsdMunchHome)) {
    fs.rmSync(gsdMunchHome, { recursive: true, force: true })
    console.log('  Removed deployed assets from ~/.claude/gsd-munch/')
  } else {
    console.log('  ~/.claude/gsd-munch/ not found — skipping')
  }

  // 3. Remove agent files (only gsd-*.md, not other agents)
  const agentsDir = path.join(os.homedir(), '.claude', 'agents')
  if (fs.existsSync(agentsDir)) {
    const removed: string[] = []
    for (const file of fs.readdirSync(agentsDir)) {
      if (file.startsWith('gsd-') && file.endsWith('.md')) {
        fs.rmSync(path.join(agentsDir, file))
        removed.push(file)
      }
    }
    if (removed.length > 0) {
      console.log(`  Removed ${removed.length} agent files from ~/.claude/agents/`)
    } else {
      console.log('  No gsd-*.md agent files found in ~/.claude/agents/ — skipping')
    }
  } else {
    console.log('  ~/.claude/agents/ not found — skipping')
  }

  // 4. Remove MCP entry from ~/.claude.json
  const claudeJsonPath = path.join(os.homedir(), '.claude.json')
  if (fs.existsSync(claudeJsonPath)) {
    try {
      const raw = fs.readFileSync(claudeJsonPath, 'utf-8')
      const config = JSON.parse(raw) as { mcpServers?: Record<string, unknown>; [key: string]: unknown }
      if (config.mcpServers?.jcodemunch) {
        delete config.mcpServers.jcodemunch
        // Remove empty mcpServers object if no servers remain
        if (Object.keys(config.mcpServers).length === 0) {
          delete config.mcpServers
        }
        fs.writeFileSync(claudeJsonPath, JSON.stringify(config, null, 2) + '\n', 'utf-8')
        console.log('  Removed jcodemunch MCP entry from ~/.claude.json')
      }
    } catch (err) {
      console.warn(`  Warning: could not update ~/.claude.json: ${(err as Error).message}`)
    }
  }

  console.log('')
  console.log('  gsd-munch uninstalled. To reinstall, run: npm install -g gsd-munch')
}
